<div class="relative bg-gradient-to-r from-teal-50 via-emerald-50 to-cyan-50 overflow-hidden">
  <!-- Background Pattern -->
  <div class="absolute inset-0 opacity-30">
    <div class="absolute top-10 left-10 w-32 h-32 bg-teal-200 rounded-full blur-3xl"></div>
    <div class="absolute bottom-10 right-20 w-40 h-40 bg-orange-200 rounded-full blur-3xl"></div>
    <div class="absolute top-1/2 left-1/3 w-24 h-24 bg-yellow-200 rounded-full blur-2xl"></div>
  </div>

  <!-- <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
    <div class="grid grid-cols-1 lg:grid-cols-1 gap-8 items-center"> -->
  <!-- Left - Offer -->
  <!-- <div class="text-center lg:text-left">
        <div class="inline-block">
          <h2
            class="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-600 leading-none">
            30%
          </h2>
          <p
            class="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-teal-700">
            OFF
          </p>
        </div>
        <div class="mt-4">
          <p class="text-lg text-gray-700 ml-1">On</p>
          <div class="inline-flex items-center px-1 py-2 mt-0">
            <span class="text-[2.5rem] font-bold text-gray-900">BULK ORDER</span>
          </div>
        </div> 
                <img class="" src="../../../../assets/img/leftSideBanner.png" alt="Swiggy" />
      </div>
      --->

  <!-- <div class="flex justify-center lg:justify-start">
  <img
    src="../../../../assets/img/herobanner.png"
    class="max-w-max w-48 sm:w-56 md:w-64 lg:w-64 h-64 object-contain"
  />
</div> -->
  <!-- <div class="relative w-full h-[400px] overflow-hidden">
  <img
    src="../../../../assets/img/herobanner.png"
    alt="Hero Banner"
    class="absolute inset-0 w-full h-full object-contain"
  />
</div> -->
  <!-- Center - Benefits -->

  <!-- <div class="space-y-4 mx-auto lg:mx-auto">
        <div class="flex items-center justify-start space-x-3">
          <div class="flex items-center">

            <span class="text-xl md:text-2xl font-semibold text-orange-500">0</span>
          </div>
          <div class="flex items-center">
            <lucide-icon name="truck" class="w-6 h-6 text-gray-600 mr-2"></lucide-icon>
            <span class="text-xl md:text-2xl font-semibold text-gray-800">Delivery Fee</span>
          </div>
        </div>
        <div class="flex items-center justify-start space-x-3">
         
              <div class="flex items-center">
            
            <span class="text-xl md:text-2xl font-semibold text-orange-500">0</span>
          </div>
          <div class="flex items-center">
            <lucide-icon name="package" class="w-6 h-6 text-gray-600 mr-2"></lucide-icon>
            <span class="text-xl md:text-2xl font-semibold text-gray-800">Packaging Fee</span>
          </div>
        </div>
        <div class="flex items-center justify-start space-x-3">
          
              <div class="flex items-center">
            
            <span class="text-xl md:text-2xl font-semibold text-orange-500">0</span>
          </div>
          <div class="flex items-center">
            <lucide-icon name="credit-card" class="w-6 h-6 text-gray-600 mr-2"></lucide-icon>
            <span class="text-xl md:text-2xl font-semibold text-gray-800">Platform Fee</span>
          </div>
        </div>
      </div> -->



  <!-- <div class="hidden">

        <div class="">
                    <div class="w-44 h-44 rounded-xl relative">
                <img class="object-cover" src="../../../../assets/img/rightSideBanner.png" alt="Swiggy" />
                </div>
                </div>
                 

      </div> -->
  <!-- </div>
  </div> -->

  <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12" style="cursor: pointer;"
    (click)="navigateToBulkOrder()">

    <img src="../../../../assets/img/heroBanner.webp" class="w-full h-full object-contain object-center" />

  </div>
</div>